module.exports = __webpack_public_path__ + "00_hige.b95dd33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/00_hige.png
// module id = zI6J
// module chunks = 0